export default "__VITE_ASSET__C$AtcCmT__"